import * as React from 'react';
import { List } from 'react-native-paper';
import { StyleSheet, View, Text, ImageBackground } from 'react-native';
import { COLORS, FONTS, IMAGES, SIZES } from '../constants';
import { MaterialIcons } from '@expo/vector-icons';
import { Evaluation } from './'

const CategoriesList = () => {

  const [expanded, setExpanded] = React.useState(true);
  const handlePress = () => setExpanded(!expanded);

  const categoriesData = require('../../assets/json/categories.json')

  return (
    <ImageBackground
      style={styles.bg}
    >
      <View style={styles.container}>


    <List.Section
        style={{ backgroundColor : COLORS.background }}

    >
      <Text style={styles.title}>
        Do celów sprawdzianu ustala się podział żołnierzy zawodowych na następujące kategorie:
      </Text>
      <List.Accordion
        title={categoriesData[0].name}
        left={props => <List.Icon {...props} icon="folder" />}
        // style={{ backgroundColor : COLORS.dark }}
        >

        <Text style={styles.content}>
          <MaterialIcons name="adjust" size={12} color={COLORS.light} />
          {categoriesData[0].definition}</Text>
          <Evaluation category="0"/>

      </List.Accordion>

      <List.Accordion
        title={categoriesData[1].name}
        left={props => <List.Icon {...props} icon="folder" />}>

        <Text style={styles.content}>
          <MaterialIcons name="adjust" size={10} color={COLORS.light} />
          {categoriesData[1].definition}
          {categoriesData[1].subsections.a}</Text>

        <Text style={styles.content}>
          <MaterialIcons name="adjust" size={10} color={COLORS.light} />
          {categoriesData[1].definition}
          {categoriesData[1].subsections.b}</Text>

        <Text style={styles.content}>
          <MaterialIcons name="adjust" size={10} color={COLORS.light} />
          {categoriesData[1].definition}
          {categoriesData[1].subsections.c}</Text>

        <Text style={styles.content}>
          <MaterialIcons name="adjust" size={10} color={COLORS.light} />
          {categoriesData[1].definition}
          {categoriesData[1].subsections.d}</Text>

        <Text style={styles.content}>
          <MaterialIcons name="adjust" size={10} color={COLORS.light} />
          {categoriesData[1].definition}
          {categoriesData[1].subsections.e}</Text>

          <Evaluation category="1"/>

      </List.Accordion>

      <List.Accordion
        title={categoriesData[2].name}
        left={props => <List.Icon {...props} icon="folder" />}
        expanded={expanded}
        onPress={handlePress}>

        <Text style={styles.content}>
          <MaterialIcons name="airplanemode-active" size={10} color={COLORS.accent} />
          {categoriesData[2].definition}</Text>
          <Evaluation category="2"/>

      </List.Accordion>

      <List.Accordion
        title={categoriesData[3].name}
        left={props => <List.Icon {...props} icon="folder" />}>
        <Text style={styles.content}>
          <MaterialIcons name="admin-panel-settings" size={10} color={COLORS.light} />
          {categoriesData[3].definition}</Text>
          <Evaluation category="3"/>

      </List.Accordion>

      <List.Accordion
        title={categoriesData[4].name}
        left={props => <List.Icon {...props} icon="folder" />}>
        <Text style={styles.content}>
          <MaterialIcons name="accessible-forward" size={10} color={COLORS.light} />
          {categoriesData[4].definition}</Text>
          <Evaluation category="4"/>

      </List.Accordion>

    </List.Section>
    </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  container: {
    // alignItems: 'center',
    // justifyContent: 'center',
    flex: 1,
    // backgroundColor: COLORS.background,
    marginBottom: 20,
    paddingBottom: 20,
  },
  title: {
    ...FONTS.info,
    marginBottom: 10,
    paddingLeft: 30
  },
  content: {
    color: COLORS.light,
    fontWeight: '300',
    fontSize: 14,
    textAlign: 'justify',
    paddingRight: 30,
    paddingLeft: 30,
    paddingVertical: 5,
  },
  bg: {
    backgroundColor: COLORS.background,
    width: "100%",
    height: "100%"
  }
});

export default CategoriesList;